// Rinnova editorial split — rotates the photo stage and its shoppable list together.
class RinnovaEditorial extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-rinnova-edit-slide]'));
    this.segs = Array.from(this.querySelectorAll('[data-rinnova-edit-prog]'));
    this.index = 0;
    this.timer = null;
    this.autoplay = parseInt(this.dataset.autoplay, 10) || 5500;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.slides.length === 0) return;

    this.goTo(0);

    if (this.slides.length > 1 && !this.reduceMotion) {
      this.start();
      document.addEventListener('visibilitychange', this.onVisibility);
    }

    this.addEventListener('shopify:block:select', this.onBlockSelect);
    this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
    this.addEventListener('click', this.onRowClick);
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibility);
    this.removeEventListener('click', this.onRowClick);
  }

  // Righe in modalità "occhiata veloce": apre il modale quick add del tema invece
  // di seguire il link alla scheda prodotto. In modalità "scheda prodotto" la riga
  // non ha l'attributo e ci pensa <product-card> a navigare.
  onRowClick = (event) => {
    const row = event.target.closest('[data-rinnova-quick-view]');
    if (!row || !this.contains(row)) return;

    // I controlli (pulsante +, form) e le aperture in nuova scheda restano intatti.
    if (event.target.closest('button, input, label, select')) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;

    const quickAdd = row.querySelector('quick-add-component');
    if (!quickAdd || typeof quickAdd.handleClick !== 'function') return;

    event.preventDefault();
    quickAdd.handleClick(event);
    this.pauseWhileDialogOpen();
  };

  // Ferma la rotazione mentre il modale è aperto, così alla chiusura si ritrova la
  // stessa scena da cui si è partiti.
  pauseWhileDialogOpen() {
    const dialog = document.getElementById('quick-add-dialog');
    if (!dialog) return;

    this.stop();
    dialog.addEventListener(
      'dialog:close',
      () => {
        if (!this.reduceMotion && this.slides.length > 1) this.start();
      },
      { once: true }
    );
  }

  goTo(i) {
    this.index = (i + this.slides.length) % this.slides.length;
    this.slides.forEach((el, idx) => el.classList.toggle('is-active', idx === this.index));
    this.segs.forEach((seg, idx) => {
      seg.classList.remove('is-active', 'is-done');
      if (idx < this.index) {
        seg.classList.add('is-done');
      } else if (idx === this.index) {
        // Re-trigger the fill animation on the active segment.
        void seg.offsetWidth;
        seg.classList.add('is-active');
      }
    });
  }

  next = () => this.goTo(this.index + 1);

  start() {
    this.stop();
    if (this.slides.length < 2) return;
    this.timer = window.setInterval(this.next, this.autoplay);
  }

  stop() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  onVisibility = () => {
    if (document.hidden) {
      this.stop();
    } else if (!this.reduceMotion && this.slides.length > 1) {
      this.start();
    }
  };

  onBlockSelect = (event) => {
    const slide = event.target.closest('[data-rinnova-edit-slide]');
    if (slide) {
      const i = this.slides.indexOf(slide);
      if (i >= 0) this.goTo(i);
    }
    this.stop();
  };

  onBlockDeselect = () => {
    if (!this.reduceMotion && this.slides.length > 1) this.start();
  };
}

if (!customElements.get('rinnova-editorial')) {
  customElements.define('rinnova-editorial', RinnovaEditorial);
}
